var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachment16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0501 9.45009L6.5501 1.95009C5.3001 0.650092 3.2501 0.650092 1.9501 1.90009C0.650098 3.15009 0.650098 5.25009 1.9501 6.50009L2.0001 6.55009L3.4001 8.00009L4.1001 7.30009L2.6501 5.85009C1.8001 5.00009 1.8001 3.55009 2.6501 2.70009C3.5001 1.85009 4.9501 1.80009 5.8001 2.65009C5.8001 2.65009 5.8001 2.65009 5.8501 2.70009L13.3001 10.1501C14.2001 11.0001 14.2001 12.4501 13.3501 13.3001C12.5001 14.2001 11.0501 14.2001 10.2001 13.3501C10.2001 13.3501 10.2001 13.3501 10.1501 13.3001L6.4501 9.60009C5.9501 9.10009 6.0001 8.30009 6.4501 7.85009C6.9501 7.40009 7.7001 7.40009 8.2001 7.85009L10.2501 9.90009L10.9501 9.20009L8.8501 7.10009C7.9501 6.25009 6.5501 6.30009 5.7001 7.20009C4.9001 8.05009 4.9001 9.40009 5.7001 10.3001L9.4501 14.0501C10.7001 15.3501 12.7501 15.3501 14.0501 14.1001C15.3501 12.8501 15.3501 10.7501 14.0501 9.45009C14.0501 9.50009 14.0501 9.45009 14.0501 9.45009Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment16);
export default __webpack_public_path__ + "static/media/Attachment16.90211ce77d114fbc967b9bb967e8b274.svg";
export { ForwardRef as ReactComponent };